import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import cx from 'classnames';
import messages from '../../MLSummary.messages'

import styles from '../../MLSummary.module.scss'
import { IconButton } from '@jutro/legacy/components';

function MLRentedTDCVehicles({ data, show, rentedTDCDetailsOpen }) {
    const translator = useTranslator();
    const [didUpdate, setDidUpdate] = useState(false);

    if (_.isEmpty(data)) {
        return null;
    }

    const toggleVehicleDetails = (vehicle) => {
        rentedTDCDetailsOpen[vehicle.parentPublicID_ML] = !rentedTDCDetailsOpen[vehicle.parentPublicID_ML];
        setDidUpdate(!didUpdate);
    };


    const generateHeader = () => {
        return (
            <thead>
                <tr>
                    <th />
                    <th>{translator(messages.Year)}</th>
                    <th>{translator(messages.Make)}</th>
                    <th>{translator(messages.Model)}</th>
                    <th>{translator(messages.serialNumber)}</th>
                </tr>
            </thead>
        );
    }

    if (show) {

        const rentedTDCList = data
            .filter(vehicle => vehicle.rentedTDCVehicles_ML) // only vehicles with rented TDC
            .map(vehicle => ({
                ...vehicle.rentedTDCVehicles_ML,
                parentPublicID_ML: vehicle.publicID_ML,
            }));

        return (
            <div className="vertical-spacing-40">
                <h2 className="section-header vertical-spacing-20">
                    {translator(messages.rentedTDCVehicles)}
                </h2>
                <table className={cx('table table-striped', styles.tableStriped)}>
                    {generateHeader()}
                    <tbody>
                        {rentedTDCList.map((vehicle) => {
                            const iconStyle = rentedTDCDetailsOpen[vehicle.parentPublicID_ML] ? cx(styles.iconBlue, 'icon-accordion-down', 'icon-rotate-180') : cx(styles.iconBlue, 'icon-accordion-down')
                            return (
                                <>
                                    <tr>
                                        <td className="table-data-collapse">
                                            <h2 className="subsection-header">
                                                <IconButton
                                                    onClick={() => toggleVehicleDetails(vehicle)}
                                                    role="menuitem"
                                                    icon="icon-accordion-down"
                                                    className={iconStyle}
                                                />
                                            </h2>
                                        </td>
                                        <td><strong>{vehicle.year}</strong></td>
                                        <td>{vehicle.make}</td>
                                        <td>{vehicle.model}</td>
                                        {(vehicle.vin_ML) ? <td>{vehicle.vin_ML}</td> : <></>}
                                        {(vehicle.serial_ML && !vehicle.vin_ML) ? <td>{vehicle.serial_ML}</td> : <></>}
                                    </tr>
                                    <tr />
                                </>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
    return (<></>);
}

MLRentedTDCVehicles.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
    rentedTDCDetailsOpen: PropTypes.arrayOf(PropTypes.shape({})),
    show: PropTypes.bool
};
MLRentedTDCVehicles.defaultProps = {
    data: [],
    rentedTDCDetailsOpen: [],
    show: false
};

export default MLRentedTDCVehicles;
